module.exports = __webpack_public_path__ + "static/media/Costas.b14d3e21.png";